import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import LandingPage from "@/pages/LandingPage";
import DraftPage from "@/pages/DraftPage";
import FounderPage from "@/pages/FounderPage";
import PhilosophyPage from "@/pages/PhilosophyPage";
import CraftPage from "@/pages/CraftPage";
import JournalPage from "@/pages/JournalPage";
import JoinPage from "@/pages/JoinPage";

const PageShell = () => {
  const location = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1 });
    lenisRef.current = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  const isDraft = location.pathname === "/draft";

  return (
    <>
      {!isDraft && <Nav />}
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
        >
          <Routes location={location}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/founder" element={<FounderPage />} />
            <Route path="/philosophy" element={<PhilosophyPage />} />
            <Route path="/craft" element={<CraftPage />} />
            <Route path="/journal" element={<JournalPage />} />
            <Route path="/join" element={<JoinPage />} />
            <Route path="/draft" element={<DraftPage />} />
          </Routes>
          {!isDraft && <Footer />}
        </motion.div>
      </AnimatePresence>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageShell />
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{ style: { background: "#2C241E", color: "#EFE8DC", border: "none" } }}
      />
    </div>
  );
}

export default App;
